import { VarianteTurbantes } from "types";

/**
 * Landing de campana de turbantes: tres paginas casi identicas, una por publico.
 *
 * Se reparten por canales privados (WhatsApp, bio de Instagram, contacto corporativo)
 * y el sufijo hex existe para que no sean adivinables ni terminen indexadas. Por eso
 * tampoco figuran en `DesktopMenu` ni en `MobileMenu`.
 *
 * Viven en `constants/` y no en el modulo de la pagina porque las consumen `App`,
 * `AppLayout` y `AppViews`, y hacerlo al reves introduciria un import circular.
 */
export const RUTAS_TURBANTES: Record<string, VarianteTurbantes> = {
  "/min-6fce08ece3": "minorista",
  "/may-b8cc24a452": "mayorista",
  "/corp-d539034e51": "corporativo",
};

/**
 * Indica si un pathname corresponde a la landing de turbantes.
 *
 * Contempla la barra final y las sub-rutas porque en `AppViews` las rutas se registran
 * con splat, igual que el resto de las secciones del sitio.
 */
export const esRutaTurbantes = (pathname: string): boolean =>
  Object.keys(RUTAS_TURBANTES).some(
    (ruta) => pathname === ruta || pathname.startsWith(`${ruta}/`)
  );
